"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.returnStatement = ({ ast, execObject }) => {
    const result = execObject.interpreter({ ast: ast.children.rules[0], execObject });
    execObject.manager.variable.returnValue = result;
    return result;
};
